"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var CategoriesColumn_1 = require("./CategoriesColumn");
var OptionsPane_1 = require("./OptionsPane");
var OptionsPaneError_1 = require("./OptionsPaneError");
var OptionsPaneLoading_1 = require("./OptionsPaneLoading");
var SettingsFormHeader_1 = require("./SettingsFormHeader");
var SubCategoriesColumn_1 = require("./SubCategoriesColumn");
var styling_1 = require("@uifabric/styling");
var mobx_react_1 = require("mobx-react");
var Modal_1 = require("office-ui-fabric-react/lib/Modal");
var owa_options_orchestration_1 = require("owa-options-orchestration");
var owa_options_store_1 = require("owa-options-store");
var React = require("react");
var ReactDOM = require("react-dom");
var styles = require('./OptionsFull.scss');
var className = require('classnames/bind').bind(styles);
var OptionsFull = /** @class */ (function (_super) {
    tslib_1.__extends(OptionsFull, _super);
    function OptionsFull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OptionsFull.prototype.render = function () {
        var store = owa_options_store_1.getStore();
        var subcategoriesForCategory = owa_options_store_1.getCurrentCategory().subcategories;
        var selectedSubCategory = owa_options_store_1.getCurrentSubcategory() || {};
        var options = selectedSubCategory.options || [];
        return (React.createElement(Modal_1.Modal, { isOpen: store.isFullOptionsShown, onDismiss: this.hide, containerClassName: store.isFullOptionsShown
                ? styling_1.AnimationClassNames.slideUpIn20
                : styling_1.AnimationClassNames.slideDownOut20 },
            React.createElement("div", { className: styles.container },
                React.createElement(CategoriesColumn_1.default, null),
                React.createElement(SubCategoriesColumn_1.default, { subcategories: subcategoriesForCategory }),
                React.createElement("div", { className: className(styles.settingsPane, styling_1.AnimationClassNames.slideLeftIn20), key: store.currentSubCategoryKey },
                    React.createElement(SettingsFormHeader_1.default, { selectedSubCategory: selectedSubCategory }),
                    store.currentSubCategoryState === 0 /* Loading */ && (React.createElement(OptionsPaneLoading_1.default, null)),
                    store.currentSubCategoryState === 1 /* Loaded */ && (React.createElement(OptionsPane_1.default, { options: options })),
                    store.currentSubCategoryState === 2 /* Error */ && (React.createElement(OptionsPaneError_1.default, null))))));
    };
    OptionsFull.prototype.hide = function () {
        owa_options_orchestration_1.hideFullOptions();
    };
    OptionsFull = tslib_1.__decorate([
        mobx_react_1.observer
    ], OptionsFull);
    return OptionsFull;
}(React.Component));
exports.default = OptionsFull;
var optionsFullContainer;
function mountOptionsFullPopup() {
    if (!optionsFullContainer) {
        optionsFullContainer = document.createElement('div');
        document.body.appendChild(optionsFullContainer);
        ReactDOM.render(React.createElement(OptionsFull, null), optionsFullContainer);
    }
}
exports.mountOptionsFullPopup = mountOptionsFullPopup;
//# sourceMappingURL=OptionsFull.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/view/owa-options-view/lib/components/full/OptionsFull.js
// module id = 5285
// module chunks = 2